import { memo } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';

interface CartEmptyStateProps {
  variant?: 'drawer' | 'page';
}

/**
 * CartEmptyState (memoized)
 *
 * Shows a friendly empty state when the cart has no items.
 */
export const CartEmptyState = memo(function CartEmptyState({ variant = 'page' }: CartEmptyStateProps) {
  const { storeSlug } = useParams<{ storeSlug: string }>();
  const productsUrl = `/shop/${storeSlug}/products`;

  if (variant === 'drawer') {
    return (
      <div className="flex flex-col items-center justify-center py-12 px-4">
        <ShoppingBagIcon className="h-12 w-12 text-gray-300" />
        <p className="mt-4 text-center text-gray-500">
          Tu carrito está vacío
        </p>
        <Link
          to={productsUrl}
          className="mt-4 text-sm font-medium text-primary-600 hover:text-primary-500"
        >
          Ver productos
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="rounded-full bg-gray-100 p-6 mb-6">
        <ShoppingBagIcon className="h-12 w-12 text-gray-400" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        Tu carrito está vacío
      </h2>
      <p className="text-gray-500 text-center max-w-md mb-8">
        Parece que aún no agregaste productos a tu carrito. 
        Explorá nuestro catálogo para encontrar lo que buscás.
      </p>
      <Link
        to={productsUrl}
        className="inline-flex items-center justify-center rounded-md bg-primary-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-primary-700 transition-colors"
      >
        Explorar productos
      </Link>
    </div>
  );
});
